








































































import { Component, Vue, Prop } from 'vue-property-decorator';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import IconFont from '@/components/icons/IconFont.vue';

library.add(faChevronRight, faChevronLeft);

interface PaginationInterface {
    currentPage: number,
    totalPages: number,
}

const PAGINATION_SIZES = [10, 25, 50];
const isPaginationSize = (size: number) => PAGINATION_SIZES.includes(size);

@Component({
    components: {
        FontAwesomeIcon,
        IconFont,
    },
})
export default class Pagination extends Vue {
    @Prop({ required: true }) readonly data!: PaginationInterface;
    @Prop({ required: true }) readonly action!: string;
    @Prop({ required: false }) readonly total_items?: string;
    @Prop({ default: 50, validator: isPaginationSize }) readonly amountItems!: number;

    startPage = 1;
    stateClass = '';
    classOpen = 'open';
    listAmountItems = PAGINATION_SIZES;
    visibleList = false;

    setPage(number: number) {
        this.$store.dispatch(this.action, number);
    }

    next() {
        const page =
            this.data.currentPage + 1 <= this.data.totalPages ? this.data.currentPage + 1 : this.data.currentPage;
        this.$store.dispatch(this.action, page);
    }

    before() {
        const page = this.data.currentPage - 1 > 0 ? this.data.currentPage - 1 : this.data.currentPage;
        this.$store.dispatch(this.action, page);
    }

    toggleSelect() {
        this.stateClass = this.stateClass === this.classOpen ? '' : this.classOpen;
        this.visibleList = !this.visibleList;
    }

    selectAmount(value: number) {
        this.$emit('selectAmount', value);
    }

    documentClick(e: Event) {
        const el: any = this.$refs.dropdownAmountSelect;
        const target: any = e.target;

        if (this.visibleList) {
            if (el && el !== target && !el.contains(target)) {
                this.visibleList = false;
                this.stateClass = '';
            }
        }
    }

    created() {
        document.body.addEventListener('click', this.documentClick);
    }

    updated() {
        document.body.addEventListener('click', this.documentClick);
    }

    destroyed() {
        document.body.addEventListener('click', this.documentClick);
    }
}
